import { render, staticRenderFns } from "./CalculationExpressionBehaviorEditor.vue?vue&type=template&id=f539e738&scoped=true&"
import script from "./CalculationExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./CalculationExpressionBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CalculationExpressionBehaviorEditor.vue?vue&type=style&index=0&id=f539e738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f539e738",
  null
  
)

export default component.exports